<!-- Task creation page -->
<kl-task-creation
  [projectId]="dialogData?.data?.projectId"
  [taskId]="dialogData?.data?.taskId"
  (taskCreated)="onTaskCreation($event)">
</kl-task-creation>

<!-- / Task creation page -->
